import { Component, input } from '@angular/core';

/** 
 * Optional component that can be used within SelectComponent to group options
 * 
 * ```
 * <smw-select>
 *   <smw-select-group [label]="Group 1">
 *     <smw-select-option [option]="{ id: '1', label: 'Option 1' }"
 *     <smw-select-option [option]="{ id: '2', label: 'Option 2' }"
 *     <smw-select-option [option]="{ id: '3', label: 'Option 3' }"
 *   </smw-select-group> 
 *   <smw-select-group [label]="Group 2">
 *     <smw-select-option [option]="{ id: 'a', label: 'Option A' }"
 *     <smw-select-option [option]="{ id: 'b', label: 'Option B' }"
 *     <smw-select-option [option]="{ id: 'c', label: 'Option C' }"
 *   </smw-select-group> 
 * </smw-select>
 * ```
 */
@Component({
  selector: 'smw-select-group',
  templateUrl: 'group.component.html',
  styleUrls: ['./group.component.less'],
})
export class SelectGroupComponent {
  label = input.required();
}
